export default "/_next/static/images/axa-e53a2921267bca7812cd2ec6a186302a.svg";